module.exports = __webpack_public_path__ + "img/completed.44b62b6.png";